export const ENVIRONMENTS = {
  DEV: "dev",
  QA: "qa",
};

export const APP_BASE_URL = "ctnxt.clootrack.com";

export const TRAIL_ORG_PREFIX = "trial.";
export const DEV_TRIAL_ORG_PREFIX = "launchpad.";
